import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { StyledSubOptionsContainer } from '../BaseExcelExportDialog.styles';
import { FormulatedCheckboxProps } from './FormulatedCheckbox.props';

export const FormulatedCheckbox = ({
  formulated,
  setFormulated,
  showCondition,
}: FormulatedCheckboxProps) => {
  if (!showCondition) {
    return null;
  }

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox checked={formulated} onChange={e => setFormulated(e.target.checked)} />}
          label="Formulated"
        />
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
